<template>
  <div class="shop-content">
    <ph-header>
      <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
    </ph-header>
    <div class="balance-wrapper">
      <!-- 泰康保险 -->
       <!-- v-if="!isEdit" -->
      <section class="balance-insurance" v-if="isVTk">
        <div class="balance-insurance_text fz24 cfff">进入泰康主页填写个人资料，我们会免费为您的产品进行投保，胖虎奢侈品将对您的个人信息保密。</div>
        <div class="balance-insurance_action fz28" @click="TKinsurance" v-if="isEdit">
          <!-- <router-link tag='div' to="/pay/taikang"> -->
            <span>进入泰康主页</span>
            <!--   -->
          <!-- </router-link> -->
          <van-icon name="arrow" size="15px" slot="left" />
        </div>
      </section>

      <section class="order-info-box mb24" :class="!isVTk?'mtop_no':''">
        <div class="delivery-type ponhu-line" :class="!isVTk?'radius_no':''">
          <div class="delivery-type_lable fw">配送方式</div>
          <div class="delivery-type_value">
            <span>快递到家</span>
          </div>
          <!-- <div class="delivery-type_value"  v-if="!isEdit">
            <span>{{deliveryType == '1' ? '快递到家' : '到店自提（仅支持北京自提）' }}</span>
          </div>
          <div class="delivery-type_value"  @click="showDelivery=true" v-else>
            <span>{{deliveryType == '1' ? '快递到家' : '到店自提（仅支持北京自提）' }}</span>
            <van-icon name="arrow" size="14px" slot="left" />
          </div> -->
        </div>

        <div class="address fz28" v-if="!isEdit" >
          <div class="address-wrapper c333"  v-if="deliveryType == '2'">
            <div class="username fw">{{storeAddress.contact}}</div>
            <div class="add-info">
              <span>{{storeAddress.phone}}</span>
              <span class="c999">{{storeAddress.address}}</span>
            </div>
            <van-icon name="arrow" size="14px" slot="left"  />
          </div>
          <div class="address-wrapper c333" v-else-if="deliveryType == '1' && defaultAddress">
            <div class="username fw">{{defaultAddress.name}}</div>
            <div class="add-info">
              <span>{{defaultAddress.tel}}</span>
              <span class="c999">{{defaultAddress.address}}</span>
            </div>
          </div>
        </div>
        <div class="address fz28" v-else>
          <div class="address-wrapper c333"  v-if="deliveryType == '2'">
            <div class="username fw">发货方</div>
            <div class="add-info">
              <span class="fw">{{storeAddress.contact}} {{storeAddress.phone}}</span>
              <span class="c999">{{storeAddress.address}}</span>
            </div>
          </div>
          <div class="address-wrapper c333" @click="changeAddres(1)" v-else-if="deliveryType == '1' && !isDefault">
            <div class="username fw">{{defaultAddress.name}}</div>
            <div class="add-info">
              <span>{{defaultAddress.tel}}</span>
              <span class="c999">{{defaultAddress.address}}</span>
            </div>
            <van-icon name="arrow" size="14px" slot="left"  />
          </div>

          <div class="address-wrapper c333" @click="changeAddres(1)" v-if="deliveryType == '1' && isDefault">
            <van-cell title="请添加收货地址" is-link style="padding: 6px 0;">
              <img slot="icon" src="@/assets/img/icon_map.png" style="width: 16px;height: 20px;margin-right: 10px;" />
            </van-cell>
          </div>
        </div>

        <div class="goods-wrapper" v-if="!isEdit">
          <div class="goods-item" v-for="good in goodsInfo.goods" :key="good.goodId" @click="toGoodsInfo(good.goodId)">
            <div class="img-box">
              <img :src="good.goodLogo + '?imageView2/1/w/350/h/350'" alt="" srcset="">
            </div>
            <div class="order-content fz28">
              <div class="order-title">{{good.goodName}}</div>
              <!-- <div class="order-desc"><span>{{good.description}}</span></div> -->
              <div class="order__bottom">
                <div data-v-47aa186e="" class="order__price">¥ {{good.price}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="goods-wrapper" v-else>
          <div class="goods-item" v-for="good in goodsInfo.goods" :key="good.commodityId" @click="toGoodsInfo(good.commodityId)">
            <div class="img-box">
              <img :src="good.firstPicture + '?imageView2/1/w/350/h/350'" alt="" srcset="">
            </div>
            <div class="order-content fz28">
              <div class="order-title">{{good.brandName}} {{good.categoryName}}</div>
              <div class="order-desc"><span>{{good.description}}</span></div>
              <div class="order__bottom">
                <div data-v-47aa186e="" class="order__price">¥ {{good.discountPrice}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="freight fz24" v-if="!goodsInfo.isShipping">
          <div class="freight-title">
            <div class="flex">
              <span class='fw'>运费</span>
              <router-link to="/order/freight">
                <span>查看运费标准</span>
              </router-link>
            </div>
            <span>快递到付</span>
          </div>
          <div class="c999 fz18">此商品不包邮，我们采取运费到付，请您当面验收宝贝，确保宝贝在运输过程中 未遭到破坏。</div>
        </div>

        <van-cell-group>
           <van-field
            v-model="message"
            type="textarea"
            placeholder="买家留言"
            maxlength='100'
            rows="1"
            disabled
            autosize
             v-if="!isEdit"
          />
          <van-field
          v-else
            v-model="message"
            type="textarea"
            placeholder="买家留言"
            maxlength='100'
            rows="1"
            autosize
          />

        </van-cell-group>

      </section>

      <section class='bounty-box mb24'>
        <van-cell title="优惠券" v-if="!isEdit && goodsInfo.couponAmount" :value="coupon_text"></van-cell>
        <van-cell is-link v-if="goodsInfo.coupon != 0" :value="coupon_text" @click="chooseCoupon">
          <template #title>
            <span class="custom-title">优惠券</span>
            <van-tag plain type="danger" v-if="isCoptag">已选最优</van-tag>
          </template>
        </van-cell>

        <van-cell title="奖励金" v-if="!isEdit && goodsInfo.bountyUse != 0 ">
          <template slot="right-icon">
            <span class="custom-text">-¥{{goodsInfo.bountyUse}}</span>
          </template>
        </van-cell>
        <van-cell title="奖励金" v-if="isEdit && goodsInfo.bountyUse != 0 ">
          <template slot="right-icon">
            <span class="custom-text">余额 ¥{{goodsInfo.bountyTotal}}，可抵扣 ¥{{goodsInfo.bountyUse}}</span>
            <van-switch v-model="bountyChecked"  active-color="#282828" size="20px"  @change="bountyChange"/>
          </template>
        </van-cell>
      </section>

      <section class="pay-method-box">
        <van-radio-group v-model="paytype">
          <van-cell-group>
            <van-cell title="微信支付" clickable @click="paytype='2'" style="">
              <van-icon slot="icon" name="wechat" color="#00C800" size="22px" style="margin-right: 10px" />
              <van-radio name="2" checked-color="#FFD133" />
            </van-cell>
            <van-cell title="支付宝支付" clickable @click="paytype='1'">
              <van-icon slot="icon" name="alipay" color="#00AAEE" size="22px" style="margin-right: 10px" />
              <van-radio name="1" checked-color="#FFD133" />
            </van-cell>
            <van-cell v-if="platformChannel=='9'" title="网银转账" clickable @click="paytype='5'">
              <svg-icon slot="icon" iconClass="unionpay" class="ph-icon" style="margin-right: 10px;font-size:22px"></svg-icon>
              <van-radio name="5" checked-color="#FFD133" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </section>
    </div>

    <!-- <div class="protocol">
      <van-checkbox v-model="protocol_checked"></van-checkbox>
      <div class="protocol-info" @click="checkProtocol">我已阅读并同意<span class="protocol-link">《在线鉴定协议》</span></div>
    </div> -->
    <div class="appr-order-submit">
      <van-submit-bar
        :loading='submit_loading'
        :price="totalPrice"
        button-text="立即支付"
        label='实付：'
        @submit="onSubmit"
      >
      <span slot="tip" v-if="tips"></span>
      </van-submit-bar>
    </div>

    <van-action-sheet v-model="showDelivery" title="选择配送方式">
      <div class="actions-delivery">
        <van-radio-group v-model="deliveryType">
          <van-cell-group>
            <!-- 通过v-model绑定值当前选中项的 name -->
            <van-cell title="快递到家" clickable @click="deliveryType='1'">
              <van-radio name="1" checked-color="#FFD133" />
            </van-cell>
            <!-- <van-cell title="到店自提（仅支持北京自提）" clickable @click="deliveryType='2'">
              <van-radio name="2" checked-color="#FFD133" />
            </van-cell> -->
          </van-cell-group>
        </van-radio-group>
        <van-button type="ponhu" size="large" @click="changeDelivery" class="fw">确认</van-button>
      </div>
    </van-action-sheet>
    <van-popup v-model="showTig" style="background:transparent">
      <div class="store-popup">
        <div class="store-close" @click="showTig=false">
          <img src="@/assets/img/close.png" />
        </div>
        <div class="store-con">
          <div class="title">温馨提示</div>
          <div class="content">亲，微信中无法使用支付宝支付，请复制链接在浏览器中打开哦~</div>
          <div class="clip-btn" @click="onSelect">复制地址</div>
        </div>
      </div>
    </van-popup>
    <van-dialog
      v-model="isPay"
      title="支付是否已完成？"
      show-confirm-button
      show-cancel-button
      cancel-button-text="支付失败"
      @confirm="chackPay"
      confirm-button-text="已完成支付"
      @cancel="chackPay"
      confirm-button-color="#DA3232">
    </van-dialog>
    <div v-html="alipayWap" ref="alipayWap"></div>
  </div>
</template>
<script>
import { getDefaultAddress, getStoreAddress } from '@/api/user'
import { getBalanceGoodsDetail, createOrder, payWeChat, payAli, getOrderDetail, getTkOrder, checkPayment } from '@/api/order'
import { openApp, BrowserInfo, setLocalStorage, getLocalStorage } from '@/utils'
import { USER_OPENID } from '@/utils/constant'
import PhHeader from '@/components/common/Header'
import ClipboardJS from 'clipboard'

export default {
  name: 'appr_order',
  components: {
    PhHeader
  },
  data () {
    return {
      showDelivery: false,
      submit_loading: false,
      tips: false,
      isEdit: true,
      oid: '',
      totalPrice: 0, // 必须数字类型
      paytype: '2',
      deliveryType: '1',
      couponid: 0,
      boundInsurance: '', // 绑定泰康 1能适应 2不能使用
      protocol_checked: true,
      bountyChecked: false,
      bountyBox: false,
      coupon_text: '',
      coupon: null,
      isUseCop: true,
      isCoptag: true,
      // addressId: '',
      storeAddress: {},
      goodsInfo: {
        goods: [],
        coupon: 0,
        preferred: {},
        bountyTotal: 0,
        bountyUse: 0,
        isShipping: false
      },
      addressId: '',
      defaultAddress: {
        id: '',
        tel: '',
        name: '',
        address: ''
      },
      message: '',
      goodsId: [],
      pOpenid: '',
      isPay: false,
      isVTk: false,
      isDefault: false,
      isWeixin: false,
      showTig: false,
      orderInfo: {},
      alipayWap: ''
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    },
    platformChannel () {
      return this.$store.getters.platformChannel || '9'
    }
  },

  created() {
    let gid = this.$route.params.gid
    this.goodsId.push(gid)

    let bro = BrowserInfo()
    if (bro.isWeixin) { // 微信内置
      this.paytype = '2';
      this.isWeixin = true;
    } else {
      this.paytype = '1';
      this.isWeixin = false;
    }

    // 获取openid
    const openid =  this.$route.query.openid || ''
    if(openid) {
      // 存储openid
      setLocalStorage(USER_OPENID, openid)
      this.pOpenid = openid;
    } else {
      this.pOpenid = getLocalStorage(USER_OPENID) || ''
    }

    this.isPay = this.$route.query.tip == 'yes'
    this.oid = this.$route.query.oid || ''

    // 获取结算信息
    var balance = this.$store.getters.userBalance;
    this.addressId = balance.addressId || 0;
    this.couponid = balance.couponId || '0';
    this.coupon = balance.coupon;
    if(typeof(balance.isUse) != "undefined") {
      this.isUseCop = balance.isUse;
    }
    this.bountyChecked = balance.bChecked;

    if (this.oid) {
      this.isEdit = false
      this.getOrderInfoData()
    } else {
      if(this.token) { 
        this.getGoodsData()
        this.initAddress()
        this.getStoreAddressData()
      } else {
        this.$router.push({ path: '/login?return_url=' + window.location.href })
      }
    }
  },

  mounted() {
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
    if(this.$route.query.t) {
      this.$store.dispatch('LoginByUser', this.$route.query.t)
    }
    if(this.platformChannel == '9') {
      if (window.location.href.indexOf("?#") < 0) {
        window.location.replace(window.location.href.replace("#", "?#"));
      }
    }
  },
  // destroyed(){
  //   window.removeEventListener('popstate', this.goBack, false);
  // },
  methods: {
    // 获取商品信息
    getGoodsData () {
      getBalanceGoodsDetail({ userToken: this.token, scopeOfUse: 1, orderCommodityIds: this.goodsId }).then(res => {
        this.goodsInfo.goods = res.commodityList
        this.goodsInfo.bountyUse = res.deductibleBonus
        this.goodsInfo.bountyTotal = res.bonusBalance
        this.goodsInfo.preferred = res.preferredPrivilege

        this.goodsInfo.coupon = res.couponNumber
        if(res.couponNumber > 0 && this.couponid == '0') { // 默认现实优选优惠卷
          if(this.isUseCop) {
            this.coupon_text = `-¥ ${res.preferredPrivilege.discountedPrice}`
            this.totalPrice = Number(res.totalAmount) * 100 - Number(res.preferredPrivilege.discountedPrice) * 100
            this.couponid = res.preferredPrivilege.privilegeId;
            this.coupon = { discountedPrice: res.preferredPrivilege.discountedPrice }
          } else {
            this.totalPrice = Number(res.totalAmount) * 100
            this.coupon_text = `您有${res.couponNumber}个优惠卷`
            this.isCoptag = false;
          }
        } else {
          if(this.couponid == '0') {
            this.totalPrice = Number(res.totalAmount) * 100

          } else {
            this.coupon_text = `-¥ ${this.coupon.discountedPrice}`
            this.isCoptag = this.coupon.optimalOption
            this.totalPrice = Number(res.totalAmount) * 100 - Number(this.coupon.discountedPrice) * 100
          }
        }

        // if(this.couponid != "0") {
        //   this.coupon_text = this.coupon.privilegeName;
        //   this.totalPrice = Number(res.totalAmount) * 100 - Number(this.coupon.discountedPrice) * 100
        // } else {
        //   this.totalPrice = Number(res.totalAmount) * 100
        // }
        console.log(this.totalPrice)
        if (this.bountyChecked) {
          this.totalPrice = this.totalPrice - Number(this.goodsInfo.bountyUse) * 100
        }

        if(Number(this.totalPrice) < 0) {
          this.totalPrice = 0;
        }

        this.goodsInfo.price = res.totalAmount
        this.boundInsurance = res.boundInsurance
        this.goodsInfo.isShipping = res.shipping

        this.isVTk = res.underwriting;
      }).catch(error => {
        console.log(error)
      })
    },
    // 获取订单详情
    getOrderInfoData () {
      getOrderDetail({ userToken: this.token, soNumber: this.oid }).then(res => {
        this.orderInfo = res;
        this.goodsInfo.goods = res.goodsList
        this.goodsInfo.couponAmount = res.couponAmount
        this.goodsInfo.bountyUse = res.rewardAmount || 0

        this.coupon_text = `-¥ ${res.couponAmount}`

        this.totalPrice = res.orderAmount * 100
        this.paytype = res.paymentCode;

        this.deliveryType = res.expressType
        if (res.expressType === '2') {
          this.storeAddress = { contact: res.consignee, phone: res.consigneePhone, address: res.consigneeAddress }
        } else {
          this.defaultAddress = { name: res.consignee, tel: res.consigneePhone, address: res.consigneeAddress }
        }
      }).catch(err => {
        this.$toast(err)
      })
    },
    TKinsurance () {
      this.$router.push({ name: 'taikang', query: { gid: this.goodsId } })
    },
    // 到店自提地址
    getStoreAddressData () {
      getStoreAddress().then(res => {
        this.storeAddress = res
      }).catch(err => {
        this.$toast(err)
      })
    },
    initAddress () {
      getDefaultAddress({ userToken: this.token, addressId: this.addressId }).then(res => {
        if(res) {
          this.defaultAddress.id = res.addressId
          this.addressId = res.addressId
          this.defaultAddress.tel = res.tel
          this.defaultAddress.name = res.receiver
          this.defaultAddress.address = res.connection + res.detailedAddress
        } else {
          this.isDefault = true;
        }
        
      }).catch(err => {
        this.$toast(err)
      })
    },
    chooseCoupon () {
      this.$router.push({ name: 'coupon', query: { gids: this.goodsId.toString(), return_url: location.href } })
    },
    
    bountyChange (bountyChecked) {
      let dicPrice = 0
      if(this.couponid != "0") {
        dicPrice = Number(this.goodsInfo.price) * 100 - Number(this.coupon.discountedPrice) * 100
      } else {
        dicPrice = Number(this.goodsInfo.price) * 100
      }
      if (bountyChecked) {
        this.totalPrice = dicPrice - Number(this.goodsInfo.bountyUse) * 100
      } else {
        this.totalPrice = dicPrice
      }
      if(Number(this.totalPrice) < 0) {
        this.totalPrice = 0;
      }
      this.$store.commit('SET_USER_BALANCE', { bChecked: bountyChecked });
    },
    // 选择配送方式
    changeDelivery () {
      this.showDelivery = false
    },
    // 选择收货地址
    changeAddres (type) {
      let backUrl = location.href;
      if (type === 2) {
        // 新增
        this.$router.push({ name: 'addAddress', query: { return_url: backUrl } })
      } else {
        this.$router.push({ name: 'address', query: { return_url: backUrl } })
      }
    },
    // 查看商品详情
    toGoodsInfo (id) {
      this.$router.push({ name: 'shopGoodsDetail', params: { gid: id } })
    },
    onSubmit () {
      if(!this.isEdit) {
        if (this.paytype === '5') {
          this.$router.push({ name: 'Epay', params: { oid: this.orderInfo.soNumber } })
        } else if (this.paytype === '2') {
          // 微信支付
          this.weixinPaySubmit(this.orderInfo);
        } else if (this.paytype === '1') {
          if(!this.isWeixin) {
            // 支付宝支付
            this.alipaySubmit(this.orderInfo)
          } else {
            this.showTig = true;
          }
        }
      } else {
        if(this.isVTk) {
          getTkOrder({ userToken: this.token, goodsId: this.goodsId }).then(res => {
            if(res.cardNO) {
              if(this.platformChannel=='10') {
                this.appPay();
              } else {
                this.pay()
              }
            } else {
              this.$dialog.confirm({
                title: '提示',
                message: '绑定泰康保险',
                confirmButtonText: '去绑定'
              }).then(() => {
                this.$router.push({ name: 'taikang', query: { gid: this.goodsId } })
                return false;
              }).catch(err => {
                return false;
              })
            }
          }).catch(err => {
            this.$toast(err)
          })
        } else {
          if(this.platformChannel=='10') {
            this.appPay();
          } else {
            this.pay()
          }
        }
      }
    },
    checkProtocol () {
      this.$router.push({
        name: 'ApprPayProtocol'
      })
    },
    // app支付
    appPay() {
      let params = {
        payid: this.paytype,
        goodsid_str: this.goodsId[0],
        total: this.goodsInfo.price,
        addrid: this.addressId,
        shipping_type: this.deliveryType,
        message: this.message,
        is_use: '0',
        youhui_type: '3'
      }
      if (this.couponid != '0') { // 优惠券抵扣
        params.prid = this.couponid;
        params.dk_price;
        params.youhui_type = '4';
      }
      if (this.bountyChecked) { // 奖励金抵扣
        params.is_use = 1;
        params.dk_price = this.goodsInfo.bountyUse;
      }
      let _paramsData = JSON.stringify(params)
      var pl = BrowserInfo();
      if(pl.isIOS) {
        this.$IOS.IosAppPay(this.paytype, _paramsData, '5')
      } else {
        this.$Android.AndroidAppPay(this.paytype, _paramsData, '5')
      }
    },
    // h5支付
    pay() {
      if(this.paytype == '1') {
        if(this.isWeixin) {
          this.showTig = true;
          return false;
        }
      }

      let params = this.orderData || {}
      params.os = process.env.VUE_APP_OS
      params.osVersion = process.env.VUE_APP_OS_VERSION
      params.channelId = process.env.VUE_APP_CHANNELID
      params.userToken = this.token

      // TODO: 奖励金抵扣 判断
      params.addressId = this.addressId
      params.goodsId = this.goodsId
      params.promotionInfoList = []
      if (this.couponid != '0') { // 优惠券抵扣
        params.promotionInfoList.push({ type: 1, couponId: this.couponid })
      }
      if (this.bountyChecked) { // 奖励金抵扣
        params.promotionInfoList.push({ type: 2, useSurplus: this.bountyChecked })
      }
      // 订单金额
      params.orderAmount = Number(this.totalPrice / 100)
      // 支付方式
      params.payCode = this.paytype
      // 快递方式
      params.expressTypeCode = this.deliveryType
      // 留言
      params.message = this.message

      let bro = BrowserInfo()

      // 创建订单
      this.$toast.loading({
        mask: true,
      });
      createOrder(params).then(res => {
        this.oid = res.soNumber;
        if (this.paytype === '5') {
          this.$router.push({ name: 'Epay', params: { oid: res.soNumber } })
        } else if (this.paytype === '2') {  // 微信支付
          if (params.orderAmount == 0) {
            this.$router.push({ path: '/pay/success?oid=' + res.soNumber })
          } else {
            // 微信支付
            res.orderAmount = params.orderAmount
            this.weixinPaySubmit(res)
          }
        } else if (this.paytype === '1') {  // 支付宝支付
          if (params.orderAmount == 0) {
            this.$router.push({ path: '/pay/success?oid=' + res.soNumber })
          } else {
            // 支付宝
            res.orderAmount = params.orderAmount
            this.alipaySubmit(res)
          }
        }
        // 清理结算缓存
        this.$store.dispatch('BalanceOut')
        this.$toast.clear();
        // this.$router.replace('/pay/success')
      }).catch(err => {
        this.$toast(err)
      })
    },
    // 微信支付提交
    weixinPaySubmit(order) {
      let bro = BrowserInfo()
      var payModel = {
        body: 'h5商品购买' + order.soNumber,
        out_trade_no: order.soNumber,
        total_fee: order.orderAmount,
        attach: this.token,
        notify_url: process.env.VUE_APP_BASE_API + '/miniapps/payCallApi/payCommodityCallbackWX',
        trade_type: '',
        scene_info: '',
        openid: this.pOpenid,
        business_code: 'BUY_GOODS_VERIFY_INVENTORY'
      }
      if (bro.isWeixin) { // 微信内置
        payModel.trade_type = 'JSAPI'
      } else {
        payModel.trade_type = 'MWEB'
      }
      // 唤起支付
      payWeChat(payModel).then(data => {
        if (bro.isWeixin) { // 微信内置
          this.weixinPay(data)
        } else {
          window.location.replace(data.url + '&redirect_url=' + encodeURIComponent(window.location.href + '?tip=yes&oid='+this.oid))
        }
        this.isPay = true;
      }).catch(err => {
        this.$toast(err)
      })
    },
    weixinPay (data) {
      var vm = this
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
        }
      } else {
        vm.onBridgeReady(data)
      }
    },
    // 支付宝支付提交
    alipaySubmit(order) {
      let bro = BrowserInfo()
      var return_url = process.env.VUE_APP_ROOT_URL + 'index.html#/pay/balance/' + this.$route.params.gid + '?tip=yes&oid='+this.oid;
      var payModel = {
        body: 'h5商品购买' + order.soNumber,
        subject: '订单号' + order.soNumber,
        out_trade_no: order.soNumber,
        total_amount: order.orderAmount,
        trade_type: 'MWEB',
        notify_url: process.env.VUE_APP_BASE_API + '/miniapps/payCallApi/payCommodityCallbackZFB',
        passback_params: this.token,
        quit_url: window.location.href,
        specified_channel: '',
        return_url: return_url,
        business_code: 'BUY_GOODS_VERIFY_INVENTORY'
      }
      // 唤起支付
      payAli(payModel).then(data => {
        this.alipayWap = data;
				this.$nextTick(() => {
          this.$refs.alipayWap.children[0].submit()
        })
        this.isPay = true;
      }).catch(err => {
        this.$toast(err)
      })
    },
    onBridgeReady (data) {
      var that = this;
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          debug: true,
          'appId': data.appId,
          'timeStamp': data.timeStamp,
          'nonceStr': data.nonceStr,
          'package': data.payPackage,
          'signType': data.signType,
          'paySign': data.paySign,
          jsApiList: ['chooseWXPay']
        },
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            that.$router.replace('/pay/success')
          } else {
          }
        }
      )
    },
    chackPay () {
      checkPayment({ orderNumber: this.oid, payMethodId: this.paytype }).then(res => {
        if(res) {
          this.$router.replace('/pay/success?so=' + this.oid)
        } else {
          this.$router.replace('/pay/fail?so=' + this.oid)
        }
      })
      // 
    },

    goBack() {
      this.$router.replace({path: '/'});
      // var that = this;
      // if (that.oid) {
      //   that.$router.replace({path: '/order' } );
      // } else {
      //   that.$router.replace({path: '/goods/' + that.goodsId } );
      // }  
    },
    //复制微信
    onSelect () {
      let that = this
      var url = process.env.VUE_APP_ROOT_URL + 'index.html#/pay/balance/' + this.$route.params.gid + '?t='+this.token+'&oid='+this.oid;
      var clipboard = new ClipboardJS('.clip-btn', {
        text: function (trigger) {
          return url
        }
      })
      clipboard.on('success', function (e) {
        that.$toast('地址已经复制到粘贴板！')
        e.clearSelection()
      })

      clipboard.on('error', function (e) {
        that.$toast('该设备不支持自动复制')
      })
      this.showTig = false
    },
  }
}
</script>
<style lang = 'less' scoped >
.flex{
  display: flex;
}
/* section{
  margin-bottom: 24px;
} */
.balance-wrapper{
  position: relative;
  padding-bottom: 150px;
}
.balance-insurance{
  width: 100%;
  height:268px;
  background:url('../../assets/img/balance-bg.png') no-repeat left top;
  background-size: 100%;
  position: relative;
  color: #fff;
  &_text{
    position: absolute;
    top:44px;
    left:126px;
    text-align: left;
    padding-right: 24px;
  }
  &_action{
    position: absolute;
    bottom:80px;
    right:24px;
    text-align: left;
    padding-right: 24px;
    display: flex;
    align-items: center;
  }
}
.order-info-box{
  position: relative;
  margin-top: -50px;
  /* background: #fff; */
  .delivery-type{
    padding: 24px;
    border-radius:20px 20px 0px 0px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    &_value{
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #999;
      position: relative;
    }
  }
  .address{
    background: #fff;
    &-wrapper{
      display: flex;
      padding: 24px;
      background:url('../../assets/img/balance-line.png') no-repeat left bottom;
      background-size: 100%;
    }
    &_empty{
      background: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
    }
    .username{
      flex-basis: 200px;
    }
    .add-info{
      display: flex;
      color: #282828;
      flex-direction: column;
      flex-grow: 1;
    }
    .van-icon{
      align-self: center;
    }
  }
  .van-cell__title{
    text-align: left;
  }
  .goods-item{
    background: #fff;
    height:208px;
    position: relative;
    color: #333;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    border-bottom: 1px solid #ebedf0;
    .img-box{
      width: 144px;
      /* height: 144px; */
      img{
        display: block;
        width: 144px;
        height: 144px;
      }
    }
    .order-content{
      position: relative;
      display: flex;
      flex: 1;
      height: 90px;
      flex-direction: column;
      min-width: 0;
      flex: auto;
      margin-left: 20px;
      font-family:PingFangSC-Regular;
      .order__bottom{
        margin-top: 10px;
        .order__price{
          font-size: 32px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:#DA3232;
        }
      }
      .order-desc{
        margin-top: 10px;
        span{
          height: 40px;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .freight{
    background: #fff;
    padding: 24px;
    &-title{
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      a{margin-left: 15px;color: #DA3232}
    }
  }
}
.pay-method-box{
  .van-radio{
    display: flex;
    justify-content: flex-end;
  }
}
.bounty-box .custom-text{
  height:24px;
  font-size:24px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(153,153,153,1);
  margin-right: 20px;
}
.van-switch__node{
  background:#FFD133;
}
.van-submit-bar__text{
  text-align: left;
  padding-left: 24px;
}
.protocol{
  font-size:22px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color: #666666;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  .protocol-info{
    margin-left: 15px;
    height: 40px;
    line-height: 40px;
    .protocol-link{
      color: #4887F1;
    }
  }
}
.mtop_no {
  margin-top: 0 !important;
}
.radius_no {
  border-radius: 0 !important;
}
.actions-delivery{
  .van-radio-group{
    margin-bottom: 50px;
  }
  .van-radio{
    display: flex;
    justify-content: flex-end;
  }
}
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
.van-tag {
  margin-left: 10px;
}
.store-popup{
  width:580px;
  height:420px;
  box-sizing: border-box;
  position: relative;
  background: transparent;
  .store-close {
    width: 56px;
    height: 80px;
    position: absolute;
    right: 0;
    top: 0;
  }
  .store-con {
    position: relative;
    top: 80px;
    padding: 40px 80px;
    width:580px;
    height:340px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius:12px;
    .title{
      text-align: center;
      font-weight: bold;
      font-size: 32px;
      margin-bottom: 20px;
    }
    .content{
      word-break: break-all;
      font-size: 28px;
      margin-bottom: 20px;
    }
    .clip-btn{
      margin: 0 auto;
      text-align: center;
      width:160px;
      color: #FDD133;
      height:56px;
      line-height: 56px;
      font-size: 24px;
      background:rgba(40,40,40,1);
      border-radius:4px;
    }
  }
}
</style>
